// Central backend URL resolver.
// - When the app runs in a browser, it uses the current origin so that API calls
//   always go to the same host the frontend is served from. This makes the app
//   work transparently on the preview URL, the Emergent native deployment URL,
//   and any custom domain (e.g. app.mvpit.ca) without rebuilding.
// - Falls back to the build-time env var for non-browser contexts (tests, SSR).
export const BACKEND_URL =
  (typeof window !== 'undefined' && window.location && window.location.origin)
    ? window.location.origin
    : process.env.REACT_APP_BACKEND_URL;
